export const cipalColors = {
  palette_gray: {
    100: '#202532',
    80: '#50545E',
    60: '#838791',
    40: '#BEC0C5',
    10: '#D9DADD',
    5: '#EAEAEB',
    0: '#F2F2F3'
  },
  palette_primary: {
    125: '#3F51B5',
    100: '#3F51B5',
    0: '#F7F7F7'
  },
  palette_white: '#FFFFFF',
  palette_black: '#000000',
  palette_success: {
    100: '#086343',
    50: '#008556',
    5: '#D6F3E2'
  },
  palette_warning: {
    100: '#A64F21',
    50: '#E86825',
    5: '#FFE1BE'
  },
  palette_alert: {
    100: '#9F1B1F',
    50: '#DE1C22',
    5: '#FFD6D7'
  },
  palette_blue: {
    100: '#3F51B5',
    5: '#CBD0EC',
    0: '#F7F7F7'
  },
  blue: {
    50: '#ECEEF8',
    100: '#CACFED',
    200: '#A8B1E1',
    300: '#8692D5',
    400: '#6473C9',
    500: '#4255BD',
    600: '#354497',
    700: '#283371',
    800: '#1A224C',
    900: '#0D1126'
  },
  alert: {
    50: '#FBE9EA',
    100: '#F5C2C3',
    200: '#EE9B9D',
    300: '#E77377',
    400: '#E14C51',
    500: '#DA252A',
    600: '#AE1E22',
    700: '#831619',
    800: '#570F11',
    900: '#2C0708'
  },
  warning: {
    50: '#FBF0EA',
    100: '#F3D4C3',
    200: '#ECB89D',
    300: '#E49D77',
    400: '#DC8151',
    500: '#D5652A',
    600: '#AA5122',
    700: '#803D19',
    800: '#552811',
    900: '#2B1408'
  },
  success: {
    50: '#E7FDF5',
    100: '#BDFAE4',
    200: '#92F6D3',
    300: '#68F3C2',
    400: '#3EEFB1',
    500: '#13ECA0',
    600: '#0FBD80',
    700: '#0B8E60',
    800: '#085E40',
    900: '#042F20'
  },
  gray: {
    50: '#EFF1F5',
    100: '#D3D8E3',
    200: '#B7BFD1',
    300: '#9BA5BF',
    500: '#64739B',
    600: '#505C7C',
    700: '#3C455D',
    800: '#282E3E',
    900: '#14171F'
  },
  primary: {
    50: '#ECEEF8',
    100: '#CACFED',
    200: '#A8B1E1',
    300: '#8692D5',
    400: '#6473C9',
    500: '#4255BD',
    600: '#354497',
    700: '#283371',
    800: '#1A224C',
    900: '#0D1126'
  }
};

export const cipalSemanticColors = {
  border: {
    divider: cipalColors.palette_gray[5]
  },
  text: {
    default: cipalColors.palette_gray[60]
  }
};
